import { render } from "./CommonFormWithVendorEditor.vue?vue&type=template&id=121d197d&ts=true&lang=pug"
import script from "./CommonFormWithVendorEditor.vue?vue&type=script&lang=ts"
export * from "./CommonFormWithVendorEditor.vue?vue&type=script&lang=ts"

import "./CommonFormWithVendorEditor.vue?vue&type=style&index=0&id=121d197d&lang=scss"

import exportComponent from "C:\\Users\\ZiegFreeze\\Documents\\Work\\upa-fast-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__